import styled from 'styled-components'
import { BLUE_PRINCIPAL, GREY_DARK, GREY_LIGHTEST, GREY_LIGHTS, WHITE } from '../../utils/colors'

export const Container = styled.div`
  overflow: auto;
  margin: -30px -30px 0px -30px;
  max-height: 787px;

  @media print {
    max-height: initial;
    overflow: initial;
  }
`

export const SaveExamCard = styled.div`
  padding: 34px 37px 34px 23px;
  margin: 0px -30px -30px -30px;
  border-top: 1px solid ${GREY_LIGHTEST};

  button + button {
    margin-top: 12px;
  }
`

export const ContainerHeader = styled.div`
  display: grid;
  grid-template-columns: 300px 1fr;
  align-items: center;
  margin-top: 56px;

  .button_container {
    margin-top: 85px;
  }

  .exam_info {
    margin-left: 28px;
    span {
      display: block;
      margin-left: 45px;
    }

    .text {
      margin-bottom: 45px;
      min-height: 32px;
      line-height: 32px;
      font-size: 40px;
      font-weight: bold;
      color: ${BLUE_PRINCIPAL};
    }

    .label {
      min-height: 27px;
      font-size: 18px;
      line-height: 27px;
      text-align: left;
      color: ${GREY_DARK};
    }
  }
`

export const PatientOverlayContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  background: rgba(0,0,0,0.2);
`

export const PatientOverlayCard = styled.div`
  position: relative;
  width: 100%;
  max-width: 601px;
  max-height: 302.22px;
  overflow: auto;
  background: ${WHITE};
  border: 2px solid ${GREY_LIGHTS};
  box-sizing: border-box;
  border-radius: 6.88825px;
`
